import { render, staticRenderFns } from "./manage-asset.vue?vue&type=template&id=6427f7ed&scoped=true&"
import script from "./manage-asset.vue?vue&type=script&lang=ts&"
export * from "./manage-asset.vue?vue&type=script&lang=ts&"
import style0 from "./manage-asset.vue?vue&type=style&index=0&id=6427f7ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427f7ed",
  null
  
)

export default component.exports